import { colors, fontFamilies } from '@configs/styles/config'
import styled from '@emotion/styled'
import { Tooltip } from '@nextui-org/react-latest'
import InfoIcon from '@public/static/icons/info-icon'
import { SVGProps, useState } from 'react'
import * as React from 'react'

type Props = {
  data: {
    title: string
    caption: string
    subTitle: string
    listTitle: string
    isHighlighted: boolean
    extraContent: null | React.JSX.Element
    list: {
      title: string
      description: string
    }[]
  }
}

const PricingCard = ({ data }: Props) => {
  return (
    <Container
      isHighlighted={data.isHighlighted}
      className={`${data.isHighlighted ? 'sm:scale-105 z-10' : 'scale-100'}`}
    >
      <Title>{data.title}</Title>
      <Caption>{data.caption}</Caption>
      <Subtitle>{data.subTitle}</Subtitle>
      {data.extraContent ? <>{data.extraContent}</> : <></>}
      <hr />
      <ListContainer>
        <ListTitle>{data.listTitle}</ListTitle>
        {data.list.map((item) => (
          <ListItem key={item.title}>
            <ListItemIcon>
              <TickIcon
                color={colors.uguPurple}
                width="11.71px"
                height={'8.45px'}
              />
            </ListItemIcon>
            <ListItemTitle>{item.title}</ListItemTitle>
            {item.description && <TooltipContainer item={item} />}
          </ListItem>
        ))}
      </ListContainer>
    </Container>
  )
}

export default PricingCard

const TooltipContainer = ({
  item,
}: {
  item: {
    title: string
    description: string
  }
}) => {
  const [ttOpen, setTTOpen] = useState(false)

  return (
    <Tooltip
      classNames={{
        content: 'font-[Helvetica] font-[400] max-w-[230px] sm:max-w-xs',
      }}
      content={item.description}
      color="secondary"
      isOpen={ttOpen}
    >
      <ListItemMoreIcon
        onMouseEnter={() => {
          setTTOpen(true)
        }}
        onMouseLeave={() => {
          setTTOpen(false)
        }}
        onPress={() => {
          setTTOpen((prev) => !prev)
        }}
      >
        <InfoIcon width="11.71px" height="11.71px" color={'#BBB6C6'} />
      </ListItemMoreIcon>
    </Tooltip>
  )
}

const Container = styled.div`
  width: 463px;
  display: flex;
  flex-direction: column;
  padding: 68px 71px 68px 71px;
  background-color: ${(props) =>
    props.isHighlighted ? colors.uguWhite : '#e7eaff'};
  border-radius: 44px;
  gap: 24px;
  max-height: max-content;
  box-shadow: ${(props) =>
    props.isHighlighted
      ? '0px 2px 6px rgba(0, 0, 0, 0.04), 0px 5px 18px rgba(0, 0, 0, 0.06), 0px 24px 83px rgba(0, 0, 0, 0.1)'
      : ''};
  @media screen and (max-width: 540px) {
    width: 100%;
    padding: 68px 44px 68px 44px;
  }
`
const Title = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-size: 44.15px;
  font-weight: 500;
  line-height: 50.47px;
  text-align: left;
  color: #2b1c50;
  @media screen and (max-width: 540px) {
    font-size: 32px;
    line-height: 50.47px;
  }
`
const Caption = styled.div`
  font-family: ${fontFamilies.OpenSansRegular};
  font-size: 17.62px;
  font-weight: 500;
  line-height: 30.67px;
  text-align: left;
  color: #3d2e7c;
  @media screen and (max-width: 540px) {
    font-size: 16px;
    line-height: 30.67px;
  }
`
const Subtitle = styled.div`
  font-family: ${fontFamilies.sofiaPro};
  font-size: 30.5px;
  font-weight: 400;
  line-height: 41.37px;
  text-align: left;
  color: #2b1c50;
  @media screen and (max-width: 540px) {
    font-size: 20px;
    line-height: 41.37px;
  }
`
const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`
const ListTitle = styled.div`
  font-family: Helvetica;
  font-size: 14.62px;
  font-weight: 500;
  line-height: 26.76px;
  letter-spacing: 0.08192309737205505px;
  text-align: left;
  color: #2b1c50;
`
const ListItem = styled.div`
  display: flex;
  align-items: center;
  padding: 3px 0px 3px 0px;
  gap: 24px;
`
const ListItemIcon = styled.div``
const ListItemTitle = styled.div`
  font-family: Helvetica;
  font-size: 15.62px;
  font-weight: 500;
  line-height: 26.76px;
  letter-spacing: 0.08192309737205505px;
  text-align: left;
  color: #2b1c50;
`
const ListItemMoreIcon = styled.div`
  cursor: pointer;
  margin-left: -10px;
  margin-top: 2px;
`
// const Container = styled.div``

const TickIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width="24"
      height="17"
      viewBox="0 0 24 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.66797 9.77783L7.03145 15.0824C7.42106 15.4677 8.04821 15.4677 8.43783 15.0824L21.8902 1.77783"
        stroke={props.color ? props.color : '#7181FF'}
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  )
}
